export default "__VITE_ASSET__BfTNrHKr__"